<template>
  <div class="container mt-4">
    <button @click="goBack" class="btn btn-secondary mb-3">
      <font-awesome-icon icon="arrow-left" /> Zurück zur Übersicht
    </button>

    <h2 class="text-center mb-4">Kunde bearbeiten</h2>

    <!-- Erfolgsmeldung -->
    <div v-if="successMessage" class="alert alert-success text-center" role="alert">
      {{ successMessage }}
    </div>

    <form @submit.prevent="updateCustomer" class="form-modern">
      <!-- Vorname -->
      <div class="form-group mb-4">
        <label for="firstName">Vorname:</label>
        <input type="text" id="firstName" v-model="customer.FirstName" class="form-control"
          placeholder="Vorname eingeben" />
      </div>

      <!-- Nachname -->
      <div class="form-group mb-4">
        <label for="lastName">Nachname:</label>
        <input type="text" id="lastName" v-model="customer.LastName" class="form-control"
          placeholder="Nachname eingeben" />
      </div>

      <!-- Straße -->
      <div class="form-group mb-4">
        <label for="street">Straße:</label>
        <input type="text" id="street" v-model="customer.Street" class="form-control" placeholder="Straße eingeben" />
      </div>

      <!-- PLZ -->
      <div class="form-group mb-4">
        <label for="postalCode">PLZ:</label>
        <input type="text" id="postalCode" v-model="customer.PostalCode" class="form-control"
          placeholder="PLZ eingeben" />
      </div>

      <!-- Stadt -->
      <div class="form-group mb-4">
        <label for="city">Stadt:</label>
        <input type="text" id="city" v-model="customer.City" class="form-control" placeholder="Stadt eingeben" />
      </div>

      <!-- E-Mail -->
      <div class="form-group mb-4">
        <label for="email">E-Mail:</label>
        <input type="email" id="email" v-model="customer.Email" class="form-control" placeholder="E-Mail eingeben" />
      </div>

      <!-- Telefon -->
      <div class="form-group mb-4">
        <label for="phone">Telefon:</label>
        <input type="text" id="phone" v-model="customer.Phone" class="form-control" placeholder="Telefon eingeben" />
      </div>

      <!-- Provision -->
      <div class="form-group mb-4">
        <label for="commission">Provision:</label>
        <input type="number" step="0.01" id="commission" v-model="customer.Commission" class="form-control"
          placeholder="Provision eingeben" />
      </div>

      <!-- Auszahlungsart -->
      <div class="form-group mb-4">
        <label for="payout">Auszahlungsart:</label>
        <select id="payout" v-model="customer.Payout" class="form-control" required>
          <option value="" disabled selected>Bitte wählen</option>
          <option value="Bar">Bar</option>
          <option value="Überweisung">Überweisung</option>
        </select>
      </div>


      <!-- IBAN -->
      <div class="form-group mb-4">
        <label for="iban">IBAN:</label>
        <input type="text" id="iban" v-model="customer.Iban" class="form-control" placeholder="IBAN eingeben" />
      </div>

      <!-- Bank -->
      <div class="form-group mb-4">
        <label for="bank">Bank:</label>
        <input type="text" id="bank" v-model="customer.Bank" class="form-control" placeholder="Bank eingeben" />
      </div>

      <!-- Speichern -->
      <button type="submit" class="btn btn-secondary w-100">Speichern</button>
    </form>
  </div>
</template>

<script>
import axios from '@/services/axios';

export default {
  name: 'EditCustomer',
  props: ['id'],
  data() {
    return {
      customer: {},
      successMessage: ''
    };
  },
  methods: {
    async fetchCustomer() {
      try {
        const response = await axios.get(`/customers/${this.id}`);
        this.customer = response.data;
      } catch (error) {
        console.error('Fehler beim Laden des Kunden:', error);
      }
    },
    async updateCustomer() {
      try {
        await axios.put(`/customers/${this.id}`, this.customer);
        this.successMessage = 'Kunde erfolgreich aktualisiert';

        setTimeout(() => {
          this.successMessage = '';
          this.$router.push('/customers/overview');
        }, 3000);
      } catch (error) {
        console.error('Fehler beim Aktualisieren des Kunden:', error);
      }
    },
    goBack() {
      this.$router.push('/customers');
    }
  },
  created() {
    this.fetchCustomer();
  }
};
</script>


<style scoped>
.container {
  max-width: 600px;
  margin-top: 20px;
}

h2 {
  font-weight: bold;
  color: var(--primary-color);
}

.form-modern {
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.form-group label {
  font-weight: bold;
}

.form-control {
  padding: 12px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.form-control:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

/* Einheitlicher Speichern-Button (grau) */
.btn {
  padding: 12px;
  font-size: 18px;
  background-color: #6c757d;
  border: none;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

.btn:hover {
  background-color: #5a6268;
}

.alert {
  margin-top: 20px;
  font-size: 16px;
  text-align: center;
}
</style>
